import {
    Alert,
    Button,
    Checkbox,
    Col,
    Form,
    Input,
    Modal,
    Row,
    Select,
    Switch,
} from 'antd';
import { createBusiness, getSyncBusinessDropdown, updateBusiness } from 'api/Admin/company';
import ModalDelete from 'common/Management/delete';
import { getCookie } from 'helper/cookie';
import lang from 'lang/en';
import { toUpper } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
let wordError = ''

const DrawerCompany = (props) => {
  const {
    titleDrawer,
    visible,
    stateDrawer,
    infoUser,
    setVisible,
    dataEditCompany,
    getResultTreeCompany,
    setCheckChangeTable,
    checkChangeTable,
    setCheckRenderDelete,
    permissionPage,
  } = props

  const [form] = Form.useForm()
  const token = getCookie('access_token_admin')

  // console.log('dataEditCompany', dataEditCompany)

  //delete
  const [visibleDelete, setVisibleDelete] = useState(false)

  //check id ซ้ำ
  const [hiddenError, setHiddenError] = useState(true)

  //check bug form
  const [checkClickSave, setCheckClickSave] = useState(false)

  //check permission
  const [disablePage, setDisablePage] = useState(false)
  const [isActive, setIsActive] = useState(true)
  const [strategicBu, setStrategicBu] = useState(false)
  const [stratigic_Slug, setStratigic_Slug] = useState('')

  // sync business unit dropdown
  const [syncBuOptions, setSyncBuOptions] = useState([])
  const [syncBuLoading, setSyncBuLoading] = useState(false)
  // selected chips: array of { id, label }
  const [selectedSyncBu, setSelectedSyncBu] = useState([])

  useEffect(() => {
    stateDrawer == 'edit'
      ? permissionPage.update
        ? setDisablePage(false)
        : setDisablePage(true)
      : _
  }, [visible == true])

  useEffect(() => {
    if (visible && stateDrawer === 'edit' && dataEditCompany) {
      setIsActive(dataEditCompany?.status === 'Active')
    } else if (visible && stateDrawer === 'add') {
      setIsActive(true)
    }
  }, [visible, stateDrawer, dataEditCompany])

  const language = getCookie('lang')
  const word = lang[language]

  const onChangeUseTheTemplate = (e) => {
    setStrategicBu(e.target.checked)
    if (e.target.checked === true) {
      setStratigic_Slug(['strategic'])
    } else {
      setStratigic_Slug([])
    }
  }

  const fetchSyncBuOptions = useCallback(
    async (search = '') => {
      setSyncBuLoading(true)
      try {
        const res = await getSyncBusinessDropdown({ token, search })
        if (res?.status === 200) {
          const result = res.data?.result || []
          setSyncBuOptions(result.map((item) => ({ id: item.id, label: `${item.code} ${item.name}` })))
        }
      } catch (e) {
        console.error(e)
      } finally {
        setSyncBuLoading(false)
      }
    },
    [token],
  )

  // load dropdown when modal opens
  useEffect(() => {
    if (visible) {
      fetchSyncBuOptions()
    }
  }, [visible])

  // keep form field in sync with selectedSyncBu
  useEffect(() => {
    form.setFieldsValue({ business_unit: selectedSyncBu.map((x) => x.id) })
  }, [selectedSyncBu])

  const onSyncBuChange = (selectedIds) => {
    setSelectedSyncBu([
      // keep existing ACTIVE selections that are still selected
      ...selectedSyncBu.filter((s) => !s.inactive && selectedIds.includes(s.id)),
      // add newly selected items from the current dropdown options
      ...syncBuOptions.filter(
        (o) => selectedIds.includes(o.id) && !selectedSyncBu.find((s) => s.id === o.id),
      ),
    ])
    fetchSyncBuOptions('')
  }

  const onSyncBuDeselect = (deselectedId) => {
    setSelectedSyncBu(selectedSyncBu.filter((s) => s.id !== deselectedId))
  }

  const onSyncBuSearch = (searchText) => {
    fetchSyncBuOptions(searchText)
  }

  const onSyncBuDropdownVisibleChange = (open) => {
    if (open) {
      fetchSyncBuOptions('')
    }
  }

  const renderButton_Drawer = () => {
    const switchEl = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span>Status Active :</span>
        <Switch checked={isActive} onChange={setIsActive} disabled={disablePage} />
      </div>
    )

    if (checkClickSave == false) {
      if (stateDrawer === 'add') {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <Button className="BTN_Next" onClick={form.submit}>
              {word['Save']}
            </Button>
          </div>
        )
      } else {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <div>
              <Button
                className="BTN_Delete_CPF_RED"
                onClick={() => setVisibleDelete(true)}
                style={{ marginRight: 8 }}
                hidden={permissionPage.delete ? false : true}
              >
                {word['Delete']}
              </Button>
              <Button
                hidden={permissionPage.update ? false : true}
                className="BTN_Next"
                onClick={form.submit}
              >
                {word['Save']}
              </Button>
            </div>
          </div>
        )
      }
    } else {
      if (stateDrawer === 'add') {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <Button className="BTN_Next" onClick={form.submit}>
              {word['Save']}
            </Button>
          </div>
        )
      } else {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {switchEl}
            <div>
              <Button
                hidden={permissionPage.delete ? false : true}
                className="BTN_Delete_CPF_RED"
                onClick={() => setVisibleDelete(true)}
                style={{ marginRight: 8 }}
              >
                {word['Delete']}
              </Button>
              <Button
                hidden={permissionPage.update ? false : true}
                className="BTN_Next"
                onClick={form.submit}
              >
                {word['Save']}
              </Button>
            </div>
          </div>
        )
      }
    }
  }

  const onFinish = (value) => {
    setCheckClickSave(true)
    const payload = {
      business_code: value.companyCode,
      local_name: value.localName,
      name_en: value.engName,
      short_name: value.shortName,
      abbr: value.aBBR || undefined,
      tax_type_id: value.taxIDType || undefined,
      tax: value.taxID || undefined,
      local_address: value.localAddress || undefined,
      address_en: value.englishAddress || undefined,
      post_code: value.postCode || undefined,
      bank_code: value.bankCode || undefined,
      phone: value.telephone || undefined,
      email: value.eMail || undefined,
      website: value.website || undefined,
      is_strategic_project: strategicBu,
      is_active: isActive,
      sync_business_ids: selectedSyncBu.map((x) => x.id),
    }
    if (stateDrawer == 'add') {
      try {
        createBusiness({
          params: payload,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setCheckClickSave(false)
            setHiddenError(true)
            getResultTreeCompany()
            setCheckChangeTable(checkChangeTable + 1)
            SetNullForm()
            setVisible(false)
            setStrategicBu(strategicBu)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_company_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        updateBusiness({
          params: payload,
          token: token,
          id: dataEditCompany.id,
        }).then((res) => {
          getResultTreeCompany()
          setCheckChangeTable(checkChangeTable + 1)
          if (res.status === 200) {
            setCheckClickSave(false)
            SetNullForm()
            setHiddenError(true)
            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = word['err_company_code']
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const SetNullForm = () => {
    form.setFieldsValue({
      aBBR: null,
      bankCode: null,
      companyCode: null,
      createBy: null,
      eMail: null,
      engName: null,
      englishAddress: null,
      localAddress: null,
      localName: null,
      postCode: null,
      shortName: null,
      taxID: null,
      taxIDType: null,
      telephone: null,
      website: null,
      strategic_slug: false,
      business_unit: [],
    })
    setStrategicBu(false)
    setStratigic_Slug([])
    setSelectedSyncBu([])
  }

  const onClose = () => {
    setCheckClickSave(false)
    setVisible(false)
    setHiddenError(true)
    SetNullForm()
    setIsActive(true)
  }

  const onChangeCode = (event) => {
    form.setFieldsValue({
      companyCode: event.target.value.replace(/\s/g, ''),
    })
  }

  // เพิ่ม useEffect เพื่อจัดการ initial form values
  useEffect(() => {
    if (visible && !checkClickSave) {
      if (stateDrawer === 'add') {
        setIsActive(true)
        setSelectedSyncBu([])
        form.setFieldsValue({
          companyCode: null,
          createBy: infoUser.firstname + ' ' + infoUser.lastname,
          eMail: null,
          engName: null,
          aBBR: null,
          bankCode: null,
          englishAddress: null,
          localAddress: null,
          localName: null,
          postCode: null,
          shortName: null,
          taxID: null,
          taxIDType: null,
          telephone: null,
          website: null,
          strategic_slug: false,
          business_unit: [],
        })
        setStrategicBu(false)
        setStratigic_Slug([])
      } else if (stateDrawer === 'edit' && dataEditCompany) {
        setIsActive(dataEditCompany?.status === 'Active')
        const isStrategic = dataEditCompany.is_strategic_project === true

        // set initial chips from existing sync_business_ids (may include inactive items)
        const initialSyncBu = (dataEditCompany.sync_business_ids || []).map((item) => ({
          id: item.sync_business_unit_id,
          label: `${item.sync_business_units?.code ?? ''} ${item.sync_business_units?.name ?? ''}`.trim(),
          inactive: item.sync_business_units?.status !== 'Active',
        }))
        setSelectedSyncBu(initialSyncBu)

        form.setFieldsValue({
          createBy: dataEditCompany.account_name,
          companyCode: dataEditCompany.code,
          localName: dataEditCompany.name_th,
          engName: dataEditCompany.name_en,
          shortName: dataEditCompany.short_name || dataEditCompany.shot_name || null,
          aBBR: dataEditCompany.abbr_name,
          taxIDType: dataEditCompany.tax_id_type,
          taxID: dataEditCompany.tax_id,
          localAddress: dataEditCompany.address_th,
          englishAddress: dataEditCompany.address_en,
          postCode: dataEditCompany.postcode,
          bankCode: dataEditCompany.bank_code,
          telephone: dataEditCompany.telephone,
          eMail: dataEditCompany.email,
          website: dataEditCompany.website,
          strategic_slug: isStrategic,
          business_unit: initialSyncBu.map((x) => x.id),
        })
        setStrategicBu(isStrategic)
        setStratigic_Slug(isStrategic ? ['strategic'] : [])
      }
    }
  }, [visible, stateDrawer, dataEditCompany, checkClickSave])

  const onUpperCase = (e) => {
    form.setFieldsValue({
      companyCode: toUpper(e.target.value),
    })
  }
  return (
    <>
      {/* <Drawer
        maskClosable={false}
        title={<h2>{titleDrawer}</h2>}
        destroyOnClose
        placement="right"
        onClose={() => onClose()}
        visible={visible}
        width={'50vw'}
        bodyStyle={{ paddingBottom: 80 }}
        footer={renderButton_Drawer()}
      >
        <Form
          className="disable-page"
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError}>
              <Alert
                style={{ marginBottom: 10 }}
                message={wordError}
                type="error"
                showIcon
              />
            </div>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="companyCode"
                  name="companyCode"
                  label={<h4>{word['Company_Code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter company code',
                    },
                  ]}
                >
                  <Input
                    onKeyUp={onUpperCase}
                    size="large"
                    onChange={onChangeCode}
                    placeholder="Please enter company code"
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="localName"
                  name="localName"
                  label={<h4>{word['Local_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter local name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="engName"
                  name="engName"
                  label={<h4>{word['English_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter english name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="shortName"
                  name="shortName"
                  label={<h4>{word['Short_Name']}</h4>}
                >
                  <Input size="large" placeholder="Short Name" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="aBBR" name="aBBR" label={<h4>{word['ABBR_Name']}</h4>}>
                  <Input size="large" placeholder="ABBR Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item id="taxIDType" name="taxIDType" label={<h4>{word['Tax_ID_Type']}</h4>}>
                  <Input size="large" placeholder="Tax ID Type" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="taxID" name="taxID" label={<h4>{word['Tax_ID']}</h4>}>
                  <Input size="large" placeholder="Tax ID" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item id="createBy" name="createBy" label={<h4>{word['Create_by']}</h4>}>
                  <Input disabled size="large" placeholder="Create By" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="localAddress"
                  name="localAddress"
                  label={<h4>{word['Local_Address']}</h4>}
                >
                  <Input size="large" placeholder="Local Address" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="englishAddress"
                  name="englishAddress"
                  label={<h4>{word['English_Address']}</h4>}
                >
                  <Input size="large" placeholder="English Address" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="postCode" name="postCode" label={<h4>{word['Post_Code']}</h4>}>
                  <Input size="large" placeholder="Post Code" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item id="bankCode" name="bankCode" label={<h4>{word['Bank_Code']}</h4>}>
                  <Input size="large" placeholder="Bank Code" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="telephone" name="telephone" label={<h4>{word['Telephone']}</h4>}>
                  <Input size="large" placeholder="Telephone" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item id="eMail" name="eMail" label={<h4>{word['E_Mail']}</h4>}>
                  <Input size="large" placeholder="E-Mail" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="website" name="website" label={<h4>{word['Website']}</h4>}>
                  <Input size="large" placeholder="Website" />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>

        <ModalDelete
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'company'}
          data={dataEditCompany}
          renderData={getResultTreeCompany}
          setVisibleDrawer={setVisible}
          setCheckChangeTable={setCheckChangeTable}
          setCheckRenderDelete={setCheckRenderDelete}
        />
      </Drawer> */}
      <Modal
        title={<h2>{titleDrawer}</h2>}
        maskClosable={false}
        destroyOnClose
        visible={visible}
        onCancel={onClose}
        width={'634px'}
        footer={renderButton_Drawer()}
        className="fix-modal"
        placement="right"
      >
        <Form className="disable-page" form={form} layout="vertical" onFinish={onFinish}>
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError}>
              <Alert
                style={{ marginBottom: 10 }}
                message={wordError}
                type="error"
                showIcon
              />
            </div>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="companyCode"
                  name="companyCode"
                  label={<h4>{word['Business_Code']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter business code',
                    },
                  ]}
                >
                  <Input
                    onKeyUp={onUpperCase}
                    size="large"
                    onChange={onChangeCode}
                    placeholder="Please enter business code"
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="localName"
                  name="localName"
                  label={<h4>{word['Local_Name']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter local name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="engName"
                  name="engName"
                  label={<h4>{word['English_Name']}</h4>}
                  className="customValidation"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Please enter english name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="shortName"
                  name="shortName"
                  label={<h4>{word['Short_Name']}</h4>}
                >
                  <Input size="large" placeholder="Short Name" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="aBBR" name="aBBR" label={<h4>{word['ABBR_Name']}</h4>}>
                  <Input size="large" placeholder="ABBR Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="taxIDType"
                  name="taxIDType"
                  label={<h4>{word['Tax_ID_Type']}</h4>}
                >
                  <Input size="large" placeholder="Tax ID Type" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="taxID" name="taxID" label={<h4>{word['Tax_ID']}</h4>}>
                  <Input size="large" placeholder="Tax ID" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="createBy"
                  name="createBy"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input disabled size="large" placeholder="Create By" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="localAddress"
                  name="localAddress"
                  label={<h4>{word['Local_Address']}</h4>}
                >
                  <Input size="large" placeholder="Local Address" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  id="englishAddress"
                  name="englishAddress"
                  label={<h4>{word['English_Address']}</h4>}
                >
                  <Input size="large" placeholder="English Address" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="postCode"
                  name="postCode"
                  label={<h4>{word['Post_Code']}</h4>}
                >
                  <Input size="large" placeholder="Post Code" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="bankCode"
                  name="bankCode"
                  label={<h4>{word['Bank_Code']}</h4>}
                >
                  <Input size="large" placeholder="Bank Code" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  id="telephone"
                  name="telephone"
                  label={<h4>{word['Telephone']}</h4>}
                >
                  <Input size="large" placeholder="Telephone" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item id="eMail" name="eMail" label={<h4>{word['E_Mail']}</h4>}>
                  <Input size="large" placeholder="E-Mail" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item id="website" name="website" label={<h4>{word['Website']}</h4>}>
                  <Input size="large" placeholder="Website" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  id="strategic_slug"
                  name="strategic_slug"
                  style={{ marginTop: '10px' }}
                  label={<h4>{word['Use_The_Template']}</h4>}
                  valuePropName="checked" // เพิ่มบรรทัดนี้
                >
                  <Checkbox
                    onChange={onChangeUseTheTemplate}
                    style={{ fontSize: '16px' }}
                  >
                    Strategic/BU Project
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item id="business_unit" name="business_unit" label={<h4>Business Unit</h4>}>
                  <Select
                    mode="multiple"
                    size="large"
                    allowClear
                    showSearch
                    filterOption={false}
                    style={{ width: '100%' }}
                    placeholder="Please select business unit"
                    loading={syncBuLoading}
                    onSearch={onSyncBuSearch}
                    onDropdownVisibleChange={onSyncBuDropdownVisibleChange}
                    onChange={onSyncBuChange}
                    onDeselect={onSyncBuDeselect}
                    value={selectedSyncBu.map((x) => x.id)}
                    labelInValue={false}
                    optionLabelProp="label"
                    dropdownRender={(menu) => (
                      <>
                        <style>{`.bu-option-inactive { display: none !important; }`}</style>
                        {menu}
                      </>
                    )}
                    options={[
                      // selected items not yet in syncBuOptions — kept for label rendering
                      // inactive ones are hidden in dropdown via CSS, active ones show normally
                      ...selectedSyncBu
                        .filter((s) => !syncBuOptions.find((o) => o.id === s.id))
                        .map((s) => ({
                          value: s.id,
                          label: s.label,
                          ...(s.inactive ? { className: 'bu-option-inactive' } : {}),
                        })),
                      ...syncBuOptions.map((o) => ({ value: o.id, label: o.label })),
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>

        <ModalDelete
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'company'}
          data={dataEditCompany}
          renderData={getResultTreeCompany}
          setVisibleDrawer={setVisible}
          setCheckChangeTable={setCheckChangeTable}
          setCheckRenderDelete={setCheckRenderDelete}
        />
      </Modal>
    </>
  )
}
export default DrawerCompany
